module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-63.1fe65ddc.gif";